<button mat-button class="btn" (click)="onClick()" [disabled]="readonly">
  {{ model.keyword }}
</button>
